import * as React from "react";
import PubSub from "pubsub-js";
import { SCROLL_CHANGED } from "../../../lib/constants";
import type { RuntimeTheme } from "../../../lib/theme/theme";

export const scrollIDForScreenID = (id: string): string => {
    return `screenScrollView${id}`;
};

export interface ScrollInfo {
    // with format: "screenScrollView + screen.screenId"
    id: string;
    position: number;
}

interface Props {
    theme: RuntimeTheme;
}

export abstract class ScrollReactiveComponent<TProps extends Props, TState> extends React.PureComponent<
    TProps,
    TState
> {
    private token: any;

    public componentDidMount(): void {
        this.token = PubSub.subscribe(SCROLL_CHANGED, this.handleScrollChanged);
    }

    public componentWillUnmount(): void {
        PubSub.unsubscribe(this.token);
    }

    protected abstract onScrollChanged(scrollInfo: ScrollInfo): void;

    private handleScrollChanged = (_msg: string, scrollInfo: ScrollInfo) => {
        this.onScrollChanged(scrollInfo);
    };
}
